import * as React from "react";
const SvgFiRrDrone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-drone_svg__a)">
      <path
        fill="#062147"
        d="M14.707 16.122zl3.585 3.584a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-3.585-3.585A3.8 3.8 0 0 1 15 11.999a3.8 3.8 0 0 1 1.122-2.707l3.584-3.585a.999.999 0 1 0-1.414-1.414l-3.586 3.586c-1.444 1.446-3.966 1.446-5.412.001l-.001-.001-3.586-3.585a.999.999 0 1 0-1.414 1.414l3.585 3.586A3.8 3.8 0 0 1 9 12.001a3.8 3.8 0 0 1-1.122 2.708v.001l-3.584 3.584a.999.999 0 1 0 1.414 1.414l3.586-3.585a3.8 3.8 0 0 1 2.707-1.122c1.007 0 1.993.408 2.705 1.12zM12 13a6 6 0 0 0-1.106.106 5.9 5.9 0 0 0 0-2.212 5.9 5.9 0 0 0 2.212 0 5.9 5.9 0 0 0 0 2.212A6 6 0 0 0 12 13m2.158-9.249A5 5 0 0 1 19 0c2.757 0 5 2.243 5 5a4.996 4.996 0 0 1-3.751 4.842 1 1 0 1 1-.499-1.936A3 3 0 0 0 21.999 5c0-1.654-1.346-3-3-3-1.37 0-2.565.925-2.906 2.249a.999.999 0 1 1-1.936-.498zM24 19c0 2.757-2.243 5-5 5a4.996 4.996 0 0 1-4.842-3.751.998.998 0 1 1 1.936-.498A3 3 0 0 0 19 22c1.654 0 3-1.346 3-3 0-1.37-.925-2.564-2.249-2.905a.999.999 0 1 1 .498-1.936A4.996 4.996 0 0 1 24 19M9.842 20.25A5 5 0 0 1 5 24c-2.757 0-5-2.243-5-5a4.996 4.996 0 0 1 3.751-4.842.998.998 0 1 1 .498 1.936A3 3 0 0 0 2 18.999c0 1.654 1.346 3 3 3a3 3 0 0 0 2.906-2.25 1 1 0 0 1 1.937.499zM0 5c0-2.757 2.243-5 5-5a5 5 0 0 1 4.842 3.75 1 1 0 1 1-1.937.499A3 3 0 0 0 5 1.999c-1.654 0-3 1.346-3 3 0 1.37.925 2.565 2.249 2.906a.999.999 0 1 1-.499 1.936A5 5 0 0 1-.002 4.999z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-drone_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDrone;
